import axios from 'axios'
import { protocol } from '@/config'

export default {
  // getRegion: (config = {}) => axios.get('region/', config), // 获取地区
  getRegion: (config = {}) => axios.get('province', config), // 课程标准化获取地区
  getGrades: (config = {}) => axios.get('cs/grades', config), // 获取年级列表
  getSubjects: (config = {}) => axios.get('cs/subjects', config), // 获取学科列表
  // getSubjects: (config = {}) => axios.get('/subjects/', config), // 获取学科列表
  getImags: ({ adslot_id, user_id, info }, config = {}) =>
    axios.post(
      `${protocol}//api.xueersi.com/slogan/v1/search`,
      { adslot_id, user_id, info },
      config
    ), // 广告
  getNavigation: ({ login, grade, province }, config = {}) =>
    axios.post('/navigation', { login, grade, province }, config), // 获取导航信息
  getExpTag: ({ stuId, xesId }, config = {}) =>
    axios.post('/ab', { stuId, xesId }, config),
  getCartSwitch: (config = {}) => axios.get('cartSwitch', config)
}



// WEBPACK FOOTER //
// ./src/networks/api/Common/index.js